import {useRootSelector} from 'store';
import {companyAndProjectsReady} from 'store/selectors';

export function useAppIsReady() {
  return useRootSelector(companyAndProjectsReady);
}
